import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../../src/util/install_sentry'
import '../../src/refosumu/linkChange'

import './site_common'

import 'Components/refosumu/navigation_header/component'
import 'Components/refosumu/search_widget/component'
import 'Components/refosumu/search_menu/component'
import 'Components/refosumu/contract_count_widget/component'
import 'Components/refosumu/latest_high_rate_reviews_widget/component'
import 'Components/refosumu/price_average_widget/component'
import 'Components/refosumu/company_card_list/component'
import 'Components/refosumu/company_card/component'
import 'Components/refosumu/company_list_navigation/component'
import 'Components/refosumu/example_card/component'
import 'Components/refosumu/review_card/component'
import 'Components/refosumu/generals/page_header/component'
import 'Components/refosumu/main_area_navigation/component'
import 'Components/refosumu/basics/breadcrumb/component'
import 'Components/refosumu/area_questions/component'
import 'Components/refosumu/guide_columns/component'
import 'Components/refosumu/recent_example_card/component'
import 'Components/refosumu/company_ranking_widget/component'
import 'Components/refosumu/region_links/component'
import 'Components/refosumu/area_links/component'
import 'Components/refosumu/call_to_action/component'
import 'Components/refosumu/call_to_action_button/component'
import 'Components/refosumu/call_to_action_link/component'
import 'Components/refosumu/carousel_light/component'
import 'Components/refosumu/how_to_find_good_client/component'
import 'Components/refosumu/bar_chart/component'
import 'Components/refosumu/v2/floating/component'
import 'Components/refosumu/construction_experience/component'
import 'Components/refosumu/advice_card/component'
import 'Components/refosumu/call_to_action_text/component'
import 'Components/refosumu/tab_content_builder/component'
import 'Components/refosumu/lazy_load_company_card_list/component'

import spToggleNav from '../../src/spToggleNav/spToggleNav'

$(() => {
  spToggleNav()
})
